module.exports = __webpack_public_path__ + "img/success-dog.bf5e58c9.png";